<template>
    <div class="form-check">
        <b-form-checkbox v-model="form.authorized" @change="updateStatus()"></b-form-checkbox>
    </div>
</template>

<script>
    export default {
        props: {
            'item': Object,
        },

        data() {
            return {
                'form': new Form({ authorized: this.item.authorized }),
            }
        },

        mounted() {

        },

        methods: {

            updateStatus() {
                let authorized = this.form.authorized;
                this.form.post('/admin/charges/pending_shifts/' + this.item.shift_id)
                    .then(response => {
                        this.item.authorized = authorized;
                    })
                    .catch(response => {
                        this.form.authorized = !authorized;
                    });
            }

        },

        watch: {
            'item.authorized': function(val) {
                this.form.authorized = val;
            }
        }
    }
</script>
